import { useState, useEffect } from 'react';

export default function BackToTop() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-6 left-6 z-40 w-10 h-10 sm:w-12 sm:h-12 bg-teal-600 rounded-full flex items-center justify-center shadow-lg hover:bg-teal-700 transition-all hover:scale-110 cursor-pointer whitespace-nowrap"
          aria-label="Volver arriba"
        >
          <i className="ri-arrow-up-line text-white text-lg sm:text-xl"></i>
        </button>
      )}
    </>
  );
}
